/*******************************************************************************
**
** Aerospace Unified Theme Scripts
**
*******************************************************************************/


// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.
import { CustomBtn } from './components/_aero-button';

(function () {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll('.toast')
    .forEach((toastElement) => new Toast(toastElement));
})();


// *******************************************************************************************
// *******************************************************************************************

//                                Components script

// *******************************************************************************************
// *******************************************************************************************
// Custom buttton script
CustomBtn();


/*******************************************************************************
**
** Aerospace Unified Theme Menu Scripts
**
*******************************************************************************/

(function () {

  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    window.addEventListener("scroll", function () {
      if (this.scrollY <= 100) {
        document.getElementsByClassName('aerospace-navigation')[0].classList.add("nav-top-100");
      }
      else {
        document.getElementsByClassName('aerospace-navigation')[0].classList.remove("nav-top-100");
      }
    }, false);
  }

  const navMenu = document.querySelector("nav.aerospace-navigation");



  if (navMenu) {
    const MOBILE_BREAKPOINT = 1024;
    const windowWidth = () => window.innerWidth;
    const isMobileView = () => windowWidth() <= MOBILE_BREAKPOINT;
    const navbarNav = navMenu.querySelector("ul.navbar-nav");
    const dropdownL1 = navMenu.querySelector(".dropdown-l1");
    const dropdownL1All = navMenu.querySelectorAll(".menu-level-one");
    const dropdownMenuList = navMenu.querySelector(".dropdown-menu-list");
    const dropdownActive = navMenu.querySelectorAll(".nav-item.menu-level-one");
    const navLink = navMenu.querySelectorAll(".menu-level-one > .nav-link");
    const navbarWrapper = navMenu.querySelector(".navbar-wrapper");
    const dropdownMenu = document.getElementById("dropdown-menu-list");
    const body = document.querySelector("body");
    console.log("window width: ", windowWidth());

    const navbarToggler = navMenu.querySelector(".navbar-toggler");
    let pendingCloseResetTimeout = null;
    let pendingCloseResetCleanup = null;
    let hoverResetReleaseHandler = null;
    const hoverBorderResetTargets = () => navMenu.querySelectorAll(
      ".navbar-nav .nav-item.menu-level-one a.dropdown-toggle, " +
      ".navbar-nav .nav-item.menu-level-one span.dropdown-toggle, " +
      ".dropdown-menu-list > .nav-item:not(.system-dropdown) .has-megamenu ul li a.menu-title.has-children, " +
      ".navbar-nav .has-megamenu div.row:not(.investors-section) ul li a.nav-link, " +
      ".navbar-nav .has-megamenu div.row.investors-section ul li a.nav-link"
    );

    const clearHoverBorderReset = () => {
      hoverBorderResetTargets().forEach((link) => {
        link.style.removeProperty("border-left");
      });
      if (hoverResetReleaseHandler) {
        window.removeEventListener("mousemove", hoverResetReleaseHandler);
        window.removeEventListener("mousedown", hoverResetReleaseHandler);
        window.removeEventListener("keydown", hoverResetReleaseHandler);
        window.removeEventListener("touchstart", hoverResetReleaseHandler);
        hoverResetReleaseHandler = null;
      }
    };

    const suppressDesktopHoverBorderUntilInteraction = () => {
      if (isMobileView()) {
        clearHoverBorderReset();
        return;
      }

      hoverBorderResetTargets().forEach((link) => {
        link.style.setProperty("border-left", "0.0625rem solid transparent", "important");
      });

      if (hoverResetReleaseHandler) {
        window.removeEventListener("mousemove", hoverResetReleaseHandler);
        window.removeEventListener("mousedown", hoverResetReleaseHandler);
        window.removeEventListener("keydown", hoverResetReleaseHandler);
        window.removeEventListener("touchstart", hoverResetReleaseHandler);
      }

      hoverResetReleaseHandler = () => {
        clearHoverBorderReset();
      };

      window.addEventListener("mousemove", hoverResetReleaseHandler);
      window.addEventListener("mousedown", hoverResetReleaseHandler);
      window.addEventListener("keydown", hoverResetReleaseHandler);
      window.addEventListener("touchstart", hoverResetReleaseHandler);
    };

    const syncNavbarTogglerIcon = () => {
      if (!navbarToggler) {
        return;
      }
      const togglerIcon = navbarToggler.querySelector("span");
      if (!togglerIcon) {
        return;
      }
      togglerIcon.className = navbarToggler.classList.contains("nav-toggled") ? "ficon-close" : "navbar-toggler-icon";
    };

    const resetMenuToDefault = () => {
      const mobileView = isMobileView();
      navMenu.classList.remove("mobile-nav-active");
      navMenu.classList.remove("bg-blue");
      navMenu.classList.remove("hide-sticky-nav");
      navMenu.style.background = "";
      body.classList.remove("mobile-menu-overlay");
      body.classList.remove("dropmenu-overlay");

      if (navbarWrapper) {
        navbarWrapper.classList.remove("mega-menu-open");
      }

      dropdownL1All.forEach((item) => {
        item.classList.remove("current-active");
        item.classList.remove("active-item");
        const subMenu = item.querySelector(".dropdown-menu");
        if (subMenu) {
          subMenu.classList.remove("show");
          subMenu.style.visibility = mobileView ? '' : 'hidden';
          subMenu.style.opacity = mobileView ? '' : '0';
        }
      });

      navMenu.querySelectorAll(".dropdown-menu.show").forEach((menu) => menu.classList.remove("show"));

      if (dropdownMenuList) {
        dropdownMenuList.classList.remove("l2-is-active");
        dropdownMenuList.classList.remove("l3-is-active");
      }

      document.querySelectorAll(".dropdown-l2-active").forEach((item) => item.classList.remove("dropdown-l2-active"));
      document.querySelectorAll(".dropdown-l3-active").forEach((item) => item.classList.remove("dropdown-l3-active"));

      suppressDesktopHoverBorderUntilInteraction();

      if (navbarToggler) {
        navbarToggler.classList.remove("nav-toggled");
      }
      syncNavbarTogglerIcon();
    };

    const clearPendingCloseReset = () => {
      if (pendingCloseResetTimeout) {
        clearTimeout(pendingCloseResetTimeout);
        pendingCloseResetTimeout = null;
      }
      if (pendingCloseResetCleanup) {
        pendingCloseResetCleanup();
        pendingCloseResetCleanup = null;
      }
    };

    const resetMenuAfterCloseAnimation = () => {
      clearPendingCloseReset();

      if (!isMobileView() || !navbarWrapper) {
        resetMenuToDefault();
        return;
      }

      let isCompleted = false;
      const completeReset = () => {
        if (isCompleted) {
          return;
        }
        isCompleted = true;
        clearPendingCloseReset();
        resetMenuToDefault();
      };

      const onTransitionEnd = (event) => {
        if (event.target !== navbarWrapper) {
          return;
        }
        if (event.propertyName && event.propertyName !== "height") {
          return;
        }
        completeReset();
      };

      const onAnimationEnd = (event) => {
        if (event.target !== navbarWrapper) {
          return;
        }
        completeReset();
      };

      pendingCloseResetCleanup = () => {
        navbarWrapper.removeEventListener("transitionend", onTransitionEnd);
        navbarWrapper.removeEventListener("animationend", onAnimationEnd);
      };

      navbarWrapper.addEventListener("transitionend", onTransitionEnd);
      navbarWrapper.addEventListener("animationend", onAnimationEnd);
      pendingCloseResetTimeout = setTimeout(completeReset, 900);
    };

    if (navbarToggler) {
      console.log("toggler found");
      navbarToggler.addEventListener("click", () => {
        if (!isMobileView()) {
          return;
        }

        const isClosingMenu = navbarToggler.classList.contains("nav-toggled");
        if (isClosingMenu) {
          clearPendingCloseReset();
          navbarToggler.classList.remove("nav-toggled");
          navMenu.classList.remove("mobile-nav-active");
          body.classList.remove("mobile-menu-overlay");
          syncNavbarTogglerIcon();
          resetMenuAfterCloseAnimation();
          return;
        }

        clearPendingCloseReset();
        navbarToggler.classList.toggle("nav-toggled");
        navMenu.classList.toggle("mobile-nav-active");
        body.classList.toggle("mobile-menu-overlay");
        syncNavbarTogglerIcon();
      });
    }

    const desktopOnlyLinks = navMenu.querySelectorAll('.dataDesktopTrue');
    if (desktopOnlyLinks.length) {
      desktopOnlyLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          if (!isMobileView()) {
            return;
          }
          event.preventDefault();
        });
      });
    }

    if (document.querySelectorAll(".first--level .menu-level-one")) {
      Array.from(document.querySelectorAll(".first--level .menu-level-one")).map((dropdownToggle) => {
        const ddmenu = dropdownToggle.querySelector(".nav-link.has-children");
        if (ddmenu) {
          dropdownToggle.addEventListener("click", (event) => {
            if (!isMobileView()) {
              return;
            }
            if (event.target.classList.contains("has-children")) {
              event.preventDefault();
              if (dropdownMenuList) {
                dropdownMenuList.classList.add("l2-is-active");
              }
              if (event.target.nextElementSibling !== null && event.target.nextElementSibling.classList.contains("dropdown-menu")) {
                event.target.nextElementSibling.classList.add("dropdown-l2-active")
              }
            }
          });
        }
      });
    }

    if (document.querySelectorAll(".dropdown-l1 .col ul>li.has-next-level")) {
      Array.from(document.querySelectorAll(".dropdown-l1 .col ul>li.has-next-level")).map((dropdownToggle) => {
        dropdownToggle.addEventListener("click", (event) => {
          if (!isMobileView()) {
            return;
          }
          if (dropdownMenuList) {
            dropdownMenuList.classList.add("l3-is-active");
          }
          event.target.closest("li").nextElementSibling.classList.add("dropdown-l3-active");
        });
      });
    }

    if (document.querySelectorAll(".dropdown-l1 .back-step")) {
      document.querySelectorAll(".dropdown-l1 .back-step").forEach(function (elem) {
        elem.addEventListener("click", function (event) {
          if (!isMobileView()) {
            return;
          }
          event.stopPropagation();
          if (dropdownMenuList) {
            dropdownMenuList.classList.remove("l2-is-active");
          }
          elem.closest(".dropdown-l1").classList.remove("dropdown-l2-active")
        })
      });
    }

    if (document.querySelectorAll(".dropdown-l3 .back-step2")) {
      document.querySelectorAll(".dropdown-l3 .back-step2").forEach(function (elem) {
        elem.addEventListener("click", function (event) {
          if (!isMobileView()) {
            return;
          }
          event.stopImmediatePropagation();
          if (dropdownMenuList) {
            dropdownMenuList.classList.remove("l3-is-active");
          }
          elem.closest(".dropdown-l3").classList.remove("dropdown-l3-active")
        })
      });
    }

    if (navMenu) {
      // dropdownL1.style.width = `${navbarNav.clientWidth + 100}px`;
      let hoverTimer;

      if (dropdownL1All.length) {
        Array.from(dropdownL1All).forEach(function (dropdownItems) {
          const ddmenu = dropdownItems.querySelector("div.dropdown-menu");
          if (ddmenu) {
            dropdownItems.addEventListener("mouseenter", () => {
              if (isMobileView()) {
                return;
              }
              hoverTimer = setTimeout(() => {
                navMenu.style.background = "var(--ge-atmosphere-blue)";
                dropdownItems.classList.add("current-active");
                if (navbarWrapper && !document.querySelector("body").classList.contains("toolbar-fixed")) {
                  navbarWrapper.classList.add("mega-menu-open");
                }
                document.body.classList.add("dropmenu-overlay");
                dropdownItems.querySelector(".dropdown-menu").style.visibility = 'visible';
                dropdownItems.querySelector(".dropdown-menu").style.opacity = '1';
                //document.querySelector(".aerospace-logo").style.filter = "brightness(0) saturate(100%) invert(27%) sepia(14%) saturate(4742%) hue-rotate(144deg) brightness(93%) contrast(101%)";
              }, 400);
            })
            dropdownItems.addEventListener("click", () => {
              if (isMobileView()) {
                return;
              }
              hoverTimer = setTimeout(() => {
                navMenu.style.background = "var(--ge-atmosphere-blue)";
                dropdownItems.classList.add("current-active");
                if (navbarWrapper && !document.querySelector("body").classList.contains("toolbar-fixed")) {
                  navbarWrapper.classList.add("mega-menu-open");
                }
                document.body.classList.add("dropmenu-overlay");
                dropdownItems.querySelector(".dropdown-menu").style.visibility = 'visible';
                dropdownItems.querySelector(".dropdown-menu").style.opacity = '1';
                //document.querySelector(".aerospace-logo").style.filter = "brightness(0) saturate(100%) invert(27%) sepia(14%) saturate(4742%) hue-rotate(144deg) brightness(93%) contrast(101%)";
              }, 400);
            })
            dropdownItems.addEventListener("mouseleave", () => {
              if (isMobileView()) {
                return;
              }
              setTimeout(() => {
                navMenu.style.background = "";
                dropdownItems.classList.remove("current-active");
                if (navbarWrapper && !document.querySelector("body").classList.contains("toolbar-fixed")) {
                  navbarWrapper.classList.remove("mega-menu-open");
                }
                document.body.classList.remove("dropmenu-overlay");
              }, 400);
              clearTimeout(hoverTimer);
              dropdownItems.querySelector(".dropdown-menu").style.visibility = 'hidden';
              dropdownItems.querySelector(".dropdown-menu").style.opacity = '0';
              //document.querySelector(".aerospace-logo").style.filter = "";
            })
          }
        })
      }
      else {
        setTimeout(function () {
          const ddL1All = document.querySelectorAll(".aerospace-navigation .menu-level-one");
          if (ddL1All.length) {
            Array.from(ddL1All).forEach(function (dropdownItems) {
              const ddmenu = dropdownItems.querySelector("div.dropdown-menu");
              if (ddmenu) {
                dropdownItems.addEventListener("mouseenter", () => {
                  if (isMobileView()) {
                    return;
                  }
                  hoverTimer = setTimeout(() => {
                    navMenu.style.background = "var(--ge-atmosphere-blue)";
                    dropdownItems.classList.add("current-active");
                    if (navbarWrapper && !document.querySelector("body").classList.contains("toolbar-fixed")) {
                      navbarWrapper.classList.add("mega-menu-open");
                    }
                    document.body.classList.add("dropmenu-overlay");
                    dropdownItems.querySelector(".dropdown-menu").style.visibility = 'visible';
                    dropdownItems.querySelector(".dropdown-menu").style.opacity = '1';
                    //document.querySelector(".aerospace-logo").style.filter = "brightness(0) saturate(100%) invert(27%) sepia(14%) saturate(4742%) hue-rotate(144deg) brightness(93%) contrast(101%)";
                  }, 400);
                })
                dropdownItems.addEventListener("click", () => {
                  if (isMobileView()) {
                    return;
                  }
                  hoverTimer = setTimeout(() => {
                    navMenu.style.background = "var(--ge-atmosphere-blue)";
                    dropdownItems.classList.add("current-active");
                    if (navbarWrapper && !document.querySelector("body").classList.contains("toolbar-fixed")) {
                      navbarWrapper.classList.add("mega-menu-open");
                    }
                    document.body.classList.add("dropmenu-overlay");
                    dropdownItems.querySelector(".dropdown-menu").style.visibility = 'visible';
                    dropdownItems.querySelector(".dropdown-menu").style.opacity = '1';
                    //document.querySelector(".aerospace-logo").style.filter = "brightness(0) saturate(100%) invert(27%) sepia(14%) saturate(4742%) hue-rotate(144deg) brightness(93%) contrast(101%)";
                  }, 400);
                })
                dropdownItems.addEventListener("mouseleave", () => {
                  if (isMobileView()) {
                    return;
                  }
                  setTimeout(() => {
                    navMenu.style.background = "";
                    dropdownItems.classList.remove("current-active");
                    if (navbarWrapper && !document.querySelector("body").classList.contains("toolbar-fixed")) {
                      navbarWrapper.classList.remove("mega-menu-open");
                    }
                    document.body.classList.remove("dropmenu-overlay");
                  }, 400);
                  clearTimeout(hoverTimer);
                  dropdownItems.querySelector(".dropdown-menu").style.visibility = 'hidden';
                  dropdownItems.querySelector(".dropdown-menu").style.opacity = '0';
                  //document.querySelector(".aerospace-logo").style.filter = "";
                })
              }
            })
          }
        }, 400);
      }


      if (dropdownL1) {
        Array.from(dropdownL1.querySelectorAll(".dropdown-navitems li")).map((menuListItem) => {
          const dropdownL2 = menuListItem.querySelector(".dropdown-l2");

          if (dropdownL2) {
            menuListItem.addEventListener("mouseenter", () => {
              if (isMobileView()) {
                return;
              }
              menuListItem.classList.add("active-item");
              navMenu.querySelector(".default-block").style.display = "none";
            });
            menuListItem.addEventListener("click", () => {
              if (isMobileView()) {
                return;
              }
              menuListItem.classList.add("active-item");
              navMenu.querySelector(".default-block").style.display = "none";
            });

            menuListItem.addEventListener("mouseleave", () => {
              if (isMobileView()) {
                return;
              }
              menuListItem.classList.remove("active-item");
              navMenu.querySelector(".default-block").style.display = "block";
            });
          }
        });
      }
    }

    let lastViewportMode = isMobileView() ? "mobile" : "desktop";

    const syncResponsiveNavigation = (force = false) => {
      const navMobile = document.querySelector("nav.aerospace-navigation");
      const main = document.querySelector("body main");
      const viewportMode = isMobileView() ? "mobile" : "desktop";
      const switchedMode = viewportMode !== lastViewportMode;

      if (!force && !switchedMode) {
        if (viewportMode === "mobile" && main && navMobile) {
          main.style.marginTop = navMobile.offsetHeight + 'px';
        }
        return;
      }

      if (!navMobile) {
        lastViewportMode = viewportMode;
        return;
      }

      if (viewportMode === "mobile") {
        resetMenuToDefault();
        navMenu.classList.add("fixed-top");
        navMenu.classList.add("fixed-top-mob");
        if (main) {
          main.style.marginTop = navMobile.offsetHeight + 'px';
        }
      }
      else {
        resetMenuToDefault();
        navMenu.classList.remove("fixed-top-mob");
        navMenu.classList.add("fixed-top");
        if (main) {
          main.style.marginTop = "";
        }
      }

      lastViewportMode = viewportMode;
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", syncResponsiveNavigation);
    }
    else {
      syncResponsiveNavigation(true);
    }

    let resizeTimer;
    window.addEventListener("resize", () => {
      const currentViewportMode = isMobileView() ? "mobile" : "desktop";
      if (currentViewportMode !== lastViewportMode) {
        clearTimeout(resizeTimer);
        syncResponsiveNavigation(true);
        return;
      }

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => syncResponsiveNavigation(), 150);
    });

    window.addEventListener("orientationchange", () => {
      setTimeout(() => syncResponsiveNavigation(), 180);
    });

    window.onscroll = function (e) {
      if (windowWidth() > MOBILE_BREAKPOINT) {
        if (this.oldScroll > this.scrollY) {
          navMenu.classList.add("fixed-top");
          if (this.scrollY > 10) {
            navMenu.classList.add("hide-sticky-nav");
          }
          else {
            navMenu.classList.remove("hide-sticky-nav");
          }
        }
        else {
          navMenu.classList.remove("fixed-top");
        }
        this.oldScroll = this.scrollY;
      }
      else {
        if (this.scrollY > 100) {
          navMenu.classList.add("bg-blue");
        }
        else {
          navMenu.classList.remove("bg-blue");
        }
      }
    }
  }

  /**** Adjustments to main navigation on admin pages ****/
  window.addEventListener('load', function () {
    if (navMenu != null) {
      navMenu.classList.add("fixed-top");
    }

    let menuOffsetTop = 0;

    if (document.querySelector(".block-aero-unified-primary-local")) {
      menuOffsetTop = document.querySelector(".block-aero-unified-primary-local").offsetTop + document.querySelector(".block-aero-unified-primary-local").offsetHeight;
    }
    else if (document.querySelector("#toolbar-administration")) {
      menuOffsetTop = document.querySelector("#toolbar-administration").offsetTop;
    }

    if (document.querySelector(".aerospace-navigation.fixed-top")) {
      if (document.querySelector(".aerospace-navigation.fixed-top") != null) {
        document.querySelector(".aerospace-navigation.fixed-top").style.top = menuOffsetTop + "px";
      }
    }

    let navToggler = document.querySelector("button.navbar-toggler");
    if (navToggler != null) {
      navToggler.addEventListener('click', function (e) {
        const togglerIcon = navToggler.querySelector("span");
        if (togglerIcon) {
          togglerIcon.className = navToggler.classList.contains('nav-toggled') ? 'ficon-close' : 'navbar-toggler-icon';
        }
        if (navToggler.classList.contains('nav-toggled') && document.querySelector(".aerospace-navigation .navbar-wrapper")) {
          document.querySelector(".aerospace-navigation .navbar-wrapper").style.top = menuOffsetTop + "px";
        }
      }, false);
    }
  }, false);
  /*******************************************************/

})();

/*******************************************************************************
**
** End of Aerospace Unified Theme Menu Scripts
**
*******************************************************************************/

/*******************************************************************************
** Webform scripts
*******************************************************************************/

// Execute the function on window load
window.addEventListener('load', setFormControls);

function setFormControls() {
  var formFloating = document.querySelectorAll('form.webform-submission-form .form-floating');

  formFloating.forEach((formItem) => {
    const formControl = formItem.querySelectorAll('.form-control:not(fieldset)');
    if (formControl.length) {
      formControl.forEach((control) => {
        const formLabel = getNextLabel(control);

        control.addEventListener('click', () => {
          const formLabelHeight = formLabel.clientHeight;

          if (control.tagName.toUpperCase() === 'INPUT') {
            control.style.setProperty('padding-top', (formLabelHeight - 10) + 'px', 'important');
            control.style.setProperty('padding-bottom', '5px', 'important');
          }
          else if (control.tagName.toUpperCase() === 'TEXTAREA') {
            control.style.setProperty('padding-top', (formLabelHeight - 5) + 'px', 'important');
          }
        });
      });

    }
  });
}

function getNextLabel(element) {
  let sibling = element.nextElementSibling;

  while (sibling) {
    if (sibling.tagName.toUpperCase() === 'LABEL') {
      return sibling; // Found a label sibling
    }
    sibling = sibling.nextElementSibling;
  }

  return null; // No label sibling found
}

/*******************************************************************************
** End of Webform scripts
*******************************************************************************/